import { render, staticRenderFns } from "./AZPagination.vue?vue&type=template&id=711e671f&scoped=true&"
import script from "./AZPagination.vue?vue&type=script&lang=js&"
export * from "./AZPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711e671f",
  null
  
)

export default component.exports